export function getIdFromUri(uri: string) {
  const array = uri && `${uri}`.split('/');
  const id = array?.[array.length - 1];
  return Number.isInteger(+id) ? +id : undefined;
};
